<template>
  <section class="releaseListDiv">
    <viewTitle
      title="业务管理 / 车辆安全放行 / 货车放行 / 放行名单"
      :showReturn="false"
    />

    <!-- 按钮组1 -->
    <section class="controler">
      <div class="ctrLeft" style="width: 100%;">
        <el-radio-group
          v-model="params.radioTime"
          @change="radioChange"
          size="small"
          fill="#3389f1"
          style="vertical-align: bottom;margin-right: 15px;"
        >
          <el-radio-button label="昨天"></el-radio-button>
          <el-radio-button label="今天"></el-radio-button>
          <el-radio-button label="明天"></el-radio-button>
        </el-radio-group>
        <el-date-picker
          v-model="params.time"
          type="daterange"
          align="right"
          unlink-panels
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="pickerOptions"
          @change="changeTimeRange"
        >
        </el-date-picker>
        <span class="rectl">安全状态: </span>
        <el-select
          class="ctl"
          v-model="params.state"
          placeholder="请选择"
          label="安全状态"
          clearable
          @clear="params.state = -1"
          @change="changeState"
        >
          <el-option
            :label="item"
            :value="index - 1"
            v-for="(item, index) in stateOption"
            :key="index - 1"
          ></el-option>
        </el-select>
        <el-popover
          placement="bottom"
          width="414"
          trigger="manual"
          popper-class="release_pop"
          v-model="licenseParams.visibleClose"
        >
          <template>
            <!-- 中文 -->
            <div class="allBoard_qy" v-if="licenseParams.show_zh">
              <div class="plate_number_box_qy">
                <div
                  size="small"
                  v-for="(item, index) in licenseParams.ChineseList"
                  :key="index"
                  class="btn-div_qy flex1"
                  @click="selectChinese(item)"
                >
                  <div class="btn-div-cont_qy">
                    <span v-if="item.id === 99"
                      ><img
                        src="../assets/img/delete.png"
                        width="21px"
                        style="vertical-align: middle;"
                    /></span>
                    <span v-else>{{ item.name }}</span>
                  </div>
                </div>
              </div>
            </div>
            <!-- 英文 -->
            <div class="allBoard_qy" v-if="licenseParams.show_en">
              <div class="plate_number_box_qy">
                <div
                  size="small"
                  v-for="(item, index) in licenseParams.English_Number"
                  :key="index"
                  class="btn-div_qy flex2"
                  @click="selectEnglish(item)"
                >
                  <div class="btn-div-cont_qy">
                    <span v-if="item.id === 99"
                      ><img
                        src="../assets/img/delete.png"
                        width="21px"
                        style="vertical-align: middle;"
                    /></span>
                    <span v-else>{{ item.name }}</span>
                  </div>
                </div>
              </div>
            </div>
          </template>
          <el-input
            ref="keywordInput"
            class="ctl rectl"
            style="width: 20% !important;"
            clearable
            placeholder="输入关键字搜索"
            suffix-icon="el-icon-search"
            v-model="params.keyword"
            @change="changeKeyword"
            @focus="focusKeywordInput"
            @blur="licenseParams.visibleClose = false"
            slot="reference"
          ></el-input>
        </el-popover>
        <el-button
          class="rectl"
          type="primary"
          @click="refreshData"
          size="small"
          >刷新数据</el-button
        >
      </div>
    </section>

    <!-- 列表 -->
    <section class="main-table">
      <el-table
        v-if="showTable"
        :max-height="tableMaxSize"
        style="width: 100%;"
        show-overflow-tooltip
        :data="tableData"
        header-cell-class-name="table-header-cell"
        header-row-class-name="table-header-row"
        cell-class-name="table-cell"
        :border="true"
      >
        <el-table-column label="日期">
          <template slot-scope="scope">
            {{
              scope.row.report_time === null
                ? formatTime(scope.row.booking_day)
                : formatReportTime(scope.row.report_time)
            }}
          </template>
        </el-table-column>
        <el-table-column label="运输单位">
          <template slot-scope="scope">
            {{ scope.row.unit || "--" }}
          </template>
        </el-table-column>
        <el-table-column label="车牌号">
          <template slot-scope="scope">
            {{ scope.row.license_plate || "--" }}
          </template>
        </el-table-column>
        <el-table-column label="司机姓名">
          <template slot-scope="scope">
            {{ scope.row.name || "--" }}
          </template>
        </el-table-column>
        <el-table-column label="手机号码">
          <template slot-scope="scope">
            {{ scope.row.contact || "--" }}
          </template>
        </el-table-column>
        <el-table-column label="状态">
          <template slot-scope="scope">
            <span
              :style="
                `color: ${stateColor[Number(scope.row.report_state) + 1]}`
              "
            >
              {{ stateOption[Number(scope.row.report_state) + 1] || "--" }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <div class="dropdown" @click.stop>
              <el-dropdown trigger="click" :hide-on-click="true">
                <span class="el-dropdown-link">
                  操作
                  <span class="el-icon-arrow-down"></span>
                </span>
                <el-dropdown-menu slot="dropdown" ref="dropdown">
                  <el-dropdown-item @click.native.stop="viewDetail(scope.row)">
                    查看详情
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="page-wrap">
        <pagi
          :page="page"
          :pageSize="pageSize"
          :count="count"
          @pageChange="pageChange"
        ></pagi>
      </div>
    </section>
  </section>
</template>

<script>
import moment from "moment";
import pagi from "@/components/pagi/pagi";
import viewTitle from "@/components/viewTitle";
import mixinTableLyout from "@/views/rhqy/config/mixinTableLyout.js";
import keepAliveMinxin from "@/mixins/rh/keepAliveMinxin.js";

export default {
  data() {
    return {
      // module_name: "services-advice",
      tabPosition: "left",
      page: 1,
      pageSize: 50,
      count: 0, // 表格总数
      params: {
        keyword: "", // 关键字搜索
        state: -1, // 安全状态
        radioTime: "今天", // radio默认选择的时间
        radioTimeValue: "",
        time: "", // timepicker时间
        begin_time: "",
        end_time: ""
      },
      maxSize: 0,
      tableData: [], // 表格数据
      stateOption: [
        "全部",
        "不可操作",
        "不可进厂",
        "可进厂",
        "已拒绝进厂",
        "可离厂",
        "不可离厂",
        "已拒绝离厂",
        "已离厂"
      ],
      stateColor: [
        "",
        "#B08931",
        "#00C8D2",
        "#666666",
        "#4F86F6",
        "#F5A623",
        "#666666",
        "#EC3F67",
        "#008B5E",
        "#008B5E"
      ],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一年",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      releaseListInterval: null, // 1分钟请求接口，用于保持页面不会登录超时
      licenseParams: {
        show_zh: false,
        show_en: false,
        visibleClose: false,
        ChineseList: [
          { name: "京", id: 1 },
          { name: "津", id: 2 },
          { name: "冀", id: 3 },
          { name: "晋", id: 4 },
          { name: "蒙", id: 5 },
          { name: "辽", id: 6 },
          { name: "吉", id: 7 },
          { name: "黑", id: 8 },
          { name: "沪", id: 9 },
          { name: "苏", id: 10 },
          { name: "浙", id: 11 },
          { name: "皖", id: 12 },
          { name: "闽", id: 13 },
          { name: "赣", id: 14 },
          { name: "鲁", id: 15 },
          { name: "豫", id: 16 },
          { name: "鄂", id: 17 },
          { name: "湘", id: 18 },
          { name: "粤", id: 19 },
          { name: "桂", id: 20 },
          { name: "琼", id: 21 },
          { name: "渝", id: 22 },
          { name: "川", id: 23 },
          { name: "贵", id: 24 },
          { name: "云", id: 25 },
          { name: "藏", id: 26 },
          { name: "陕", id: 27 },
          { name: "甘", id: 28 },
          { name: "青", id: 29 },
          { name: "宁", id: 30 },
          { name: "新", id: 31 },
          { name: "", id: "" },
          { name: "", id: "" },
          { name: "", id: "" },
          { name: "←", id: 99 }
        ],
        English_Number: [
          { name: "1", id: 28 },
          { name: "2", id: 29 },
          { name: "3", id: 30 },
          { name: "4", id: 31 },
          { name: "5", id: 32 },
          { name: "6", id: 33 },
          { name: "7", id: 34 },
          { name: "8", id: 35 },
          { name: "9", id: 36 },
          { name: "0", id: 37 },
          { name: "Q", id: 38 },
          { name: "W", id: 39 },
          { name: "E", id: 40 },
          { name: "R", id: 41 },
          { name: "T", id: 42 },
          { name: "Y", id: 43 },
          { name: "U", id: 44 },
          // { name: "I", id: 45 },
          // { name: "O", id: 46 },
          { name: "P", id: 47 },
          { name: "A", id: 48 },
          { name: "S", id: 49 },
          { name: "D", id: 50 },
          { name: "F", id: 51 },
          { name: "G", id: 52 },
          { name: "H", id: 53 },
          { name: "J", id: 54 },
          { name: "K", id: 55 },
          { name: "L", id: 56 },
          { name: "Z", id: 57 },
          { name: "X", id: 58 },
          { name: "C", id: 59 },
          { name: "V", id: 60 },
          { name: "B", id: 61 },
          { name: "N", id: 62 },
          { name: "M", id: 63 },
          { name: "", id: "" },
          { name: "", id: "" },
          { name: "", id: "" },
          { name: "", id: "" },
          { name: "", id: "" },
          { name: "←", id: 99 }
        ]
      },
      toKeepAlivePath: "/rhqy/service/truck/ReleaseList/detail" // 当前路由访问某个页面时的不清除缓存
    };
  },

  components: {
    pagi,
    viewTitle
  },

  computed: {
    isOverSize() {
      return this.tableData.length > 0;
    }
  },

  mixins: [mixinTableLyout, keepAliveMinxin],

  mounted() {
    console.log("mounted");
    this.params.begin_time = moment()
      .startOf("day")
      .format("YYYYMMDD");
    this.params.end_time = moment()
      .startOf("day")
      .format("YYYYMMDD");
  },

  async activated() {
    this.releaseListInterval = 0;
    this.getList();
    setTimeout(() => {
      // 1分钟定时刷新，保持页面不会登录超时
      this.releaseListInterval = window.setInterval(() => {
        this.keepLogin();
      }, 1000 * 60);
    }, 1000 * 60);
  },

  created() {},

  beforeRouteLeave(_to, _form, next) {
    window.clearInterval(this.releaseListInterval);
    this.releaseListInterval = 0;
    next();
  },

  methods: {
    // 保持页面不会登录超时
    keepLogin() {
      this.$common
        .http({
          url: "/api/permission/list_mine",
          data: {},
          noLoading: true,
          method: "GET"
        })
        .then(() => {});
    },

    // 切换页码
    pageChange(page) {
      this.page = page;
      this.getList();
    },

    // 关键字搜索
    changeKeyword() {
      // this.page = 1;
      // this.params.keyword = val;
      // this.getList();
    },

    // 选择时间范围
    changeTimeRange() {
      if (this.params.time === null) {
        this.params.begin_time = "";
        this.params.end_time = "";
        this.params.time = [];
        this.params.radioTime = "今天";
        this.params.begin_time = moment()
          .startOf("day")
          .format("YYYYMMDD");
        this.params.end_time = moment()
          .startOf("day")
          .format("YYYYMMDD");
      } else {
        this.params.radioTime = "";
        this.params.begin_time = moment(this.params.time[0]).format("YYYYMMDD");
        this.params.end_time = moment(this.params.time[1]).format("YYYYMMDD");
      }
      this.page = 1;
      this.getList();
    },

    // 格式化时间
    formatTime(str) {
      let str1 = String(str);
      let date = `${str1.substring(0, 4)}-${str1.substring(
        4,
        6
      )}-${str1.substring(6, 8)}`;
      let day = "";
      switch (moment(date).day()) {
        case 1:
          day = "周一";
          break;
        case 2:
          day = "周二";
          break;
        case 3:
          day = "周三";
          break;
        case 4:
          day = "周四";
          break;
        case 5:
          day = "周五";
          break;
        case 6:
          day = "周六";
          break;
        case 0:
          day = "周日";
          break;
      }
      let colYear = Number(str1.substring(0, 4));
      if (moment().year() === colYear) {
        return `${str1.substring(4, 6)}月${str1.substring(6, 8)}日(${day})`;
      } else {
        return `${str1.substring(0, 4)}年
          ${str1.substring(4, 6)}月
          ${str1.substring(6, 8)}日(${day})`;
      }
    },

    formatReportTime(str) {
      let str1 = str * 1000;
      let date = moment(str1).format("YYYY-MM-DD");
      let day = "";
      switch (moment(date).day()) {
        case 1:
          day = "周一";
          break;
        case 2:
          day = "周二";
          break;
        case 3:
          day = "周三";
          break;
        case 4:
          day = "周四";
          break;
        case 5:
          day = "周五";
          break;
        case 6:
          day = "周六";
          break;
        case 0:
          day = "周日";
          break;
      }
      let colYear = Number(moment(str1).format("YYYY"));
      if (moment().year() === colYear) {
        return moment(str1).format("MM月DD日") + `(${day})`;
      } else {
        return moment(str1).format("YYYY年MM月DD日") + `(${day})`;
      }
    },

    // 获取列表
    async getList() {
      let dataObj = await this.$common.http({
        url: "/api/queue/admin/query_booking",
        data: {
          booking_day: "",
          begin_time: this.params.begin_time,
          end_time: this.params.end_time,
          keyword: this.params.keyword,
          booking_state: "",
          report_state: this.params.state === -1 ? "" : this.params.state,
          page: this.page,
          page_size: this.pageSize
        }
      });
      this.tableData = dataObj.data.data.data;
      this.count = dataObj.data.data.total;
    },

    // 修改状态
    changeState() {
      this.page = 1;
      this.getList();
    },

    // 刷新数据
    refreshData() {
      this.page = 1;
      this.getList();
    },

    // 点击radio(切换时间)
    radioChange(val) {
      this.params.time = [];
      switch (val) {
        case "昨天":
          this.params.begin_time = moment()
            .subtract(1, "days")
            .format("YYYYMMDD");
          this.params.end_time = moment()
            .subtract(1, "days")
            .format("YYYYMMDD");
          break;
        case "今天":
          this.params.begin_time = moment()
            .startOf("day")
            .format("YYYYMMDD");
          this.params.end_time = moment()
            .startOf("day")
            .format("YYYYMMDD");
          break;
        case "明天":
          this.params.begin_time = moment()
            .add(1, "days")
            .format("YYYYMMDD");
          this.params.end_time = moment()
            .add(1, "days")
            .format("YYYYMMDD");
          break;
        default:
          break;
      }
      this.page = 1;
      this.getList();
    },

    // 查看详情
    viewDetail(row) {
      console.log(row);
      this.$router.push({
        path: "/rhqy/service/truck/ReleaseList/detail",
        query: {
          id: row.booking_info_id,
          type: "release"
        }
      });
    },

    // 搜索框聚焦
    focusKeywordInput() {
      this.licenseParams.visibleClose = true;
      if (this.params.keyword.trim() === "") {
        this.licenseParams.show_zh = true;
        this.licenseParams.show_en = false;
      } else if (
        /^([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领])$/.test(
          this.params.keyword.substring(0, 1)
        )
      ) {
        // 车牌号不为空时，但格式为车牌号，则显示车牌选择窗口
        let obj = this.params.keyword
          .substr(1, this.params.keyword.length)
          .split("");
        if (obj.length === 0) {
          this.licenseParams.show_zh = false;
          this.licenseParams.show_en = true;
        } else {
          obj.forEach(item => {
            if (!/^[0-9a-zA-Z]$/.test(item)) {
              this.licenseParams.show_zh = false;
              this.licenseParams.show_en = false;
            } else {
              this.licenseParams.show_zh = false;
              this.licenseParams.show_en = true;
            }
          });
        }
      } else {
        this.licenseParams.show_zh = false;
        this.licenseParams.show_en = false;
      }
    },

    // 选择中文车牌
    selectChinese(item) {
      this.$refs.keywordInput.focus();
      if (item.id === "") {
        return false;
      } else if (item.id === 99) {
        this.params.keyword = this.params.keyword.substring(
          0,
          this.params.keyword.length - 1
        );
      } else {
        this.params.keyword += item.name;
        this.licenseParams.show_zh = false;
        this.licenseParams.show_en = true;
      }
    },

    // 选择英文车牌
    selectEnglish(item) {
      this.$refs.keywordInput.focus();
      if (item.id === "") {
        return false;
      } else if (item.id === 99) {
        this.params.keyword = this.params.keyword.substring(
          0,
          this.params.keyword.length - 1
        );
        if (this.params.keyword.length === 0) {
          this.licenseParams.show_zh = true;
          this.licenseParams.show_en = false;
        }
      } else {
        this.params.keyword += item.name;
      }
    }
  },
  watch: {
    "params.keyword": function(val) {
      this.licenseParams.visibleClose = true;
      if (val.trim() === "") {
        this.licenseParams.show_zh = true;
        this.licenseParams.show_en = false;
      } else if (
        /^([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领])$/.test(
          val.substring(0, 1)
        )
      ) {
        let obj = val.substr(1, val.length).split("");
        if (obj.length === 0) {
          this.licenseParams.show_zh = false;
          this.licenseParams.show_en = true;
        } else {
          obj.forEach(item => {
            if (!/^[0-9a-zA-Z]$/.test(item)) {
              this.licenseParams.show_zh = false;
              this.licenseParams.show_en = false;
            } else {
              this.licenseParams.show_zh = false;
              this.licenseParams.show_en = true;
            }
          });
        }
      } else {
        this.licenseParams.show_zh = false;
        this.licenseParams.show_en = false;
      }
      this.page = 1;
      this.params.keyword = val;
      this.getList();
    }
  }
};
</script>

<style scoped lang="less">
@import "../assets/css/common";
.releaseListDiv {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding: 16px;
  overflow: auto;
  & > .header {
    margin: 0px 0 24px 0;
    font-size: 20px;
    line-height: 20px;
    color: #4a4a4a;
  }
  & > .controler {
    display: flex;
    margin-bottom: 16px;
    .ctl {
      display: inline-block;
      width: 10% !important;
    }
    .rectl {
      margin-left: 15px;
    }
    .ctl.mid {
      width: 16% !important;
    }
    .ctl.lar {
      width: 22% !important;
    }
    .ctrRight {
      float: right;
      margin: 0;
    }
    .ctl_fix {
      margin-top: -1px;
      margin-bottom: 0;
      line-height: 18px;
      vertical-align: middle;
      padding: 0 8px 0 10px;
      .el-range__close-icon {
        position: absolute;
        top: 0px;
        right: 2px;
      }
    }
  }
  & > .main-table {
    width: 100%;
    height: calc(100% - 169px);
    position: relative;
  }
}
.page-wrap {
  margin-top: 10px;
}
</style>
<style lang="less">
.releaseListDiv {
  .el-radio-button--small .el-radio-button__inner {
    font-size: 14px;
  }
}
// 车牌键盘样式
.release_pop {
  padding: 0px !important;
  border: 0px !important;
}
.allBoard_qy {
  display: inline-block;
  background: #fff;
  font-size: 17px;
}
.plate_number_box_qy {
  display: flex;
  width: calc(100% - 24px);
  text-align: center;
  align-content: center;
  flex-flow: row wrap;
  padding: 12px;
}
.btn-div_qy {
  word-break: break-all;
  border: 1px solid #cdcece;
  vertical-align: top;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 39px;
}
.btn-div-cont_qy {
  padding: 5px 8px;
  width: 100%;
  height: calc(100% - 10px);
  display: flex;
  align-items: center;
  justify-content: center;
}
.flex1 {
  flex: 14%;
}
.flex2 {
  width: 39px;
}
</style>
